export const YYYY_MM = 'YYYY-MM';
export const YYYYMMDD = 'YYYYMMDD';
export const YYYY_MM_DD = 'YYYY-MM-DD';
export const YYYYMMDDDAY = 'YYYY.MM.DD(ddd)';
export const YYYYMMDDHHMM = 'YYYY-MM-DD HH:mm';
export const YYYYMMDDHHMMSSZ = 'YYYY-MM-DDTHH:mm:ssZ';

export const INCREASE_LOADING = 'common/increaseLoading';
export const DECREASE_LOADING = 'common/decreaseLoading';
